import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dating-tips',
  templateUrl: './dating-tips.component.html',
  styleUrls: ['./dating-tips.component.scss']
})
export class DatingTipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
